import CommunityUserTags from './CommunityUserTags'
import SkillTags from './SkillTags'
import Tags from './Tags'

export default { SkillTags, Tags, CommunityUserTags }
